import { Component, Input, OnInit } from '@angular/core';
import { Activity } from '../models';

@Component({
  selector: 'app-watch-face',
  templateUrl: './watch-face.component.html',
  styleUrls: ['./watch-face.component.scss'],
})
export class WatchFaceComponent implements OnInit {

  @Input() activity: Activity;
  unit = (localStorage.getItem('imperial') && localStorage.getItem('imperial')==='true') ? '/mi' : 'km';
  constructor() { }

  ngOnInit() {}

}
